import React from "react";
import { Button, Box, Divider, Stack } from "@mui/material";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import LockOutlined from "@mui/icons-material/LockOutlined";
import { PRIMARY } from "../constants";
import { ProfileAreaSectionHeader } from "./layout/ProfileAreaSectionHeader";
import {
  profileFormCardBottomGapSx,
  profileFormFooterSx,
  profileSectionDividerSx,
} from "../profileFieldStyles";
import { DatiPubblici } from "./sections/DatiPubblici";
import { MetodiPagamento } from "./sections/MetodiPagamento";
import { DatiAziendali } from "./sections/DatiAziendali";
import { DatiReferente } from "./sections/DatiReferente";
import { CredenzialiCatalogo } from "./sections/CredenzialiCatalogo";
import { EDIT_ACTION_ORDER, ProfileFormEditActions } from "./ProfileFormEditActions";

export function ProfileFormCard({
  isEditing,
  isImpersonated,
  onStartEdit,
  onCancelEdit,
  vendorForm,
  fieldErrors,
  onChange,
  showLogoPreview,
  fileInputRef,
  onFileChange,
  onRemoveLogo,
  enableMetodiPagamento,
  metodiPagamenti,
  paymentSelectedIds,
  togglePaymentMethodId,
  enableLegalAddressValidation,
  sedeAddressValues,
  onSedeFieldChange,
  hasStoredAddress,
  addressNeedsReverify,
  onSedeVerifiedMerge,
  onSedeResetToVerified,
  onGeocodeServiceUnavailable,
  locationiqApiKey,
  submitDisabled,
}) {
  const readOnly = !isEditing || isImpersonated;
  const showEditActions = isEditing && !isImpersonated;

  const editActions = (
    <ProfileFormEditActions
      onCancelEdit={onCancelEdit}
      submitDisabled={submitDisabled}
      order={EDIT_ACTION_ORDER}
    />
  );

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ mb: 2 }}>
        {!isImpersonated && !isEditing ? (
          <Button
            type="button"
            variant="contained"
            onClick={onStartEdit}
            sx={{
              fontFamily: "Rubik, sans-serif",
              backgroundColor: PRIMARY,
              fontWeight: 700,
              textTransform: "none",
              borderRadius: "8px",
              px: 2.5,
              py: 1,
              "&:hover": { backgroundColor: "#092b6a" },
            }}
          >
            Modifica dati
          </Button>
        ) : null}
        {showEditActions ? (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            {editActions}
          </Stack>
        ) : null}
      </Stack>

      <ProfileAreaSectionHeader
        icon={VisibilityOutlined}
        title="Area dati visibili"
        subtitle="Questi dati sono pubblicamente visibili dagli utenti di wowcheprezzi.it"
      />

      <DatiPubblici
        vendorForm={vendorForm}
        fieldErrors={fieldErrors}
        onChange={onChange}
        showLogoPreview={showLogoPreview}
        readOnly={readOnly}
        fileInputRef={fileInputRef}
        onFileChange={onFileChange}
        onRemoveLogo={onRemoveLogo}
      />

      {enableMetodiPagamento ? (
        <>
          <Divider sx={profileSectionDividerSx} />
          <MetodiPagamento
            metodiPagamenti={metodiPagamenti}
            paymentSelectedIds={paymentSelectedIds}
            readOnly={readOnly}
            togglePaymentMethodId={togglePaymentMethodId}
          />
        </>
      ) : null}

      <Divider sx={profileSectionDividerSx} />

      <ProfileAreaSectionHeader
        icon={LockOutlined}
        title="Area dati NON visibili"
        subtitle="Questi dati sono riservati, non visibili al pubblico e custoditi da wowcheprezzi.it"
      />

      <DatiAziendali
        vendorForm={vendorForm}
        fieldErrors={fieldErrors}
        onChange={onChange}
        readOnly={readOnly}
        enableLegalAddressValidation={enableLegalAddressValidation}
        sedeAddressValues={sedeAddressValues}
        onSedeFieldChange={onSedeFieldChange}
        hasStoredAddress={hasStoredAddress}
        addressNeedsReverify={addressNeedsReverify}
        onSedeVerifiedMerge={onSedeVerifiedMerge}
        onSedeResetToVerified={onSedeResetToVerified}
        onGeocodeServiceUnavailable={onGeocodeServiceUnavailable}
        locationiqApiKey={locationiqApiKey}
      />

      <Divider sx={profileSectionDividerSx} />

      <DatiReferente
        vendorForm={vendorForm}
        fieldErrors={fieldErrors}
        onChange={onChange}
        readOnly={readOnly}
      />

      <Divider sx={profileSectionDividerSx} />

      <CredenzialiCatalogo
        vendorForm={vendorForm}
        fieldErrors={fieldErrors}
        onChange={onChange}
        readOnly={readOnly}
      />

      {showEditActions ? (
        <Box sx={profileFormFooterSx}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            justifyContent="flex-end"
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            {editActions}
          </Stack>
        </Box>
      ) : (
        <Box sx={profileFormCardBottomGapSx} aria-hidden="true" />
      )}
    </>
  );
}
